<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="640px">
        <div class="row">
            <div class="col-12">
                <x-input v-model="commentNewRow"
                         type="textarea"></x-input>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                <x-button-submit @click="onSubmit"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XModal from "../../../../components/XModal.vue";
import XInput from "../../../../components/Form/XInput.vue";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit.vue";
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue";

export default {
    name: 'DispatchItemComment',
    components: {XButtonCancel, XButtonSubmit, XInput, XModal},
    props: ["showDialog", "commentrow"],
    data() {
        return {
            title: "Comentario de producto",
            loading: false,
            errors: {},
            form: {},
            commentNewRow: null,
        };
    },
    methods: {
        handleOpen() {
            this.initForm()
            this.commentNewRow = this.commentrow
        },
        initForm() {
            this.commentNewRow = null
        },
        onSubmit() {
            this.$emit("addRowComment", this.commentNewRow)
            this.clickClose()
        },
        clickClose() {
            this.$emit("update:showDialog", false)
        },
    },
};
</script>
